(function(){
  'use strict';
  var D = document, W = window;

  // ---------- live store, pulled 23.10.2026 ----------
  // Main product /products/preserve-stack (the men product has no Loop plans yet: 422 on add-with-plan).
  // Prices = the Auto-Refill plans of the PDP. Serum = /products/ghk-cu-serum with its own Loop plans.
  var PLAN = {
    '1': {name:'1 month',  every:'every month',    bags:'1 bag every month',     v:55960842633556, sp:690913050964, price:69.90,  reg:84.90,  m:1},
    '3': {name:'3 months', every:'every 3 months', bags:'3 bags every 3 months', v:55960842666324, sp:690913083732, price:179.70, reg:254.70, m:3},
    '6': {name:'6 months', every:'every 6 months', bags:'6 bags every 6 months', v:55960842699092, sp:690913116500, price:299.40, reg:509.40, m:6}
  };
  var SERUM = {
    '1': {bottles:'1 bottle every month',     v:56433292968276, sp:691004866900, price:29.90,  reg:34.90},
    '3': {bottles:'3 bottles every 3 months', v:56433430069588, sp:691004932436, price:74.70,  reg:104.70},
    '6': {bottles:'6 bottles every 6 months', v:56433430102356, sp:691004965204, price:119.40, reg:209.40}
  };
  var KLAVIYO = {company:'XcQtZ9', list:'UbbsD3', rev:'2024-10-15'};
  var FALLBACK = 'https://myotide.co/products/preserve-stack';
  var TIER = {'1':1, '3':2, '6':3};
  var NUDGE = {
    '':  'Pick a supply and up to 40% comes off. Six months gets you the full $210.',
    '1': 'You save $15 every delivery. Three months saves $75.',
    '3': 'You save $75 every delivery. Six months gets you the full $210.',
    '6': 'You save $210 every delivery, the max.'
  };

  function $(s, r){ return (r || D).querySelector(s); }
  function $$(s, r){ return [].slice.call((r || D).querySelectorAll(s)); }
  function money(n){ return '$' + n.toFixed(2); }
  function off(o){ return Math.round(o.reg - o.price); }
  function perMo(o, m){ return o.price / m; }
  function el(tag, cls, html){ var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  var imgOf = function(sel){ var i = $(sel); return i ? (i.currentSrc || i.src) : ''; };
  var COACH = imgOf('.chip img');

  // ---------- totals for a plan + optional serum ----------
  function totals(plan, serum){
    var p = PLAN[plan], s = serum ? SERUM[plan] : null;
    var price = p.price + (s ? s.price : 0), reg = p.reg + (s ? s.reg : 0);
    return {price:price, reg:reg, mo:price / p.m, regMo:reg / p.m, save:Math.round(reg - price), m:p.m};
  }
  function items(plan, serum){
    var it = [{id:PLAN[plan].v, quantity:1, selling_plan:PLAN[plan].sp}];
    if (serum) it.push({id:SERUM[plan].v, quantity:1, selling_plan:SERUM[plan].sp});
    return it;
  }

  // ---------- checkout: fresh cart with only this plan, then Shopify checkout ----------
  var busy = false;
  function post(url, body){
    return Promise.race([
      fetch(url, {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify(body || {})}),
      new Promise(function(_, no){ setTimeout(function(){ no(new Error('timeout')); }, 12000); })
    ]);
  }
  function unbusy(){
    busy = false;
    $$('[data-t]').forEach(function(b){ b.innerHTML = b.getAttribute('data-t'); b.removeAttribute('data-t'); b.disabled = false; });
  }
  function checkout(plan, serum, btn){
    if (busy) return; busy = true;
    if (btn){ btn.disabled = true; btn.setAttribute('data-t', btn.innerHTML); btn.textContent = 'One moment…'; }
    post('/cart/clear.js')
      .then(function(r){ if (!r.ok) throw new Error('clear ' + r.status); return post('/cart/update.js', {attributes:{landing_page:'lp15-men-coach-mike'}}); })
      .then(function(){ return post('/cart/add.js', {items:items(plan, serum)}); })
      .then(function(r){ if (!r.ok) throw new Error('add ' + r.status); W.location.href = '/checkout'; })
      .catch(function(){ W.location.href = FALLBACK; });
  }
  // back from checkout: the page can come back from the back-forward cache with busy still set
  W.addEventListener('pageshow', function(e){ if (e.persisted){ unbusy(); renderBuilder(); } });

  // ---------- ghost clicks: the 2nd click of a double click must not hit what just appeared under the pointer ----------
  // (keyboard clicks have detail 0 and programmatic ones are not trusted: both pass)
  var holdUntil = 0;
  function hold(ms){ holdUntil = Date.now() + (ms || 500); }
  D.addEventListener('click', function(e){
    if (e.isTrusted && e.detail > 0 && Date.now() < holdUntil){ e.preventDefault(); e.stopPropagation(); }
  }, true);

  // ---------- builder ----------
  var S = {rx:'', plan:'', serum:false};
  var gate = $('#b-gate'), steps = $('#b-steps');
  function renderBuilder(){
    gate.hidden = !!S.rx; steps.hidden = !S.rx; $('.bcard').classList.toggle('ready', !!S.rx);
    $('#b-rxlabel').textContent = S.rx === 'no' ? 'Not on a GLP-1 yet' : 'On a GLP-1';
    $$('.feel').forEach(function(u){ u.hidden = u.getAttribute('data-for') !== S.rx; });
    $$('.plan').forEach(function(b){ var on = b.getAttribute('data-plan') === S.plan; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var sp = SERUM[S.plan || '1'], sm = PLAN[S.plan || '1'].m;
    $('#b-serum-price').innerHTML = money(perMo(sp, sm)) + '/mo<s>' + money(sp.reg / sm) + '</s><em>Save $' + off(sp) + '</em>';
    var sb = $('#b-serum-btn');
    sb.setAttribute('aria-pressed', S.serum ? 'true' : 'false');
    sb.innerHTML = S.serum ? '<i class="ic i-check"></i><span>Added</span>' : '<i class="ic i-plus"></i><span>Add</span>';
    $('#b-serum').classList.toggle('on', S.serum);
    // live panel
    var has = !!S.plan;
    $('#s-empty').hidden = has;
    var lines = $('#s-lines'); lines.innerHTML = '';
    if (has){
      var p = PLAN[S.plan];
      lines.appendChild(el('li', '', '<span><b>The Preserve Stack</b>' + p.bags + '</span><em>' + money(p.price) + '</em>'));
      if (S.serum){ var s = SERUM[S.plan]; lines.appendChild(el('li', '', '<span><b>GHK-Cu Serum</b>' + s.bottles + '</span><em>' + money(s.price) + '</em>')); }
    }
    var n = has ? TIER[S.plan] : 0;
    $$('#s-tier i').forEach(function(t, i){ t.classList.toggle('on', i < n); });
    $$('#s-tierl span').forEach(function(t, i){ t.classList.toggle('on', i === n - 1); });
    $('#s-nudge').textContent = NUDGE[S.plan] + (has && S.serum ? ' Plus $' + off(SERUM[S.plan]) + ' on the serum.' : '');
    var go = $('#s-go'), tot = $('#s-tot'), sv = $('#s-save');
    tot.hidden = sv.hidden = !has;
    if (has){
      var t = totals(S.plan, S.serum);
      $('#s-mo').textContent = money(t.mo) + '/mo'; $('#s-reg').textContent = money(t.regMo);
      sv.textContent = 'You save $' + t.save + ' every delivery · ' + money(t.price) + ' ' + PLAN[S.plan].every;
      go.disabled = false; go.innerHTML = 'Start my plan <i class="ic i-arrow"></i>';
      $('#sb-what').textContent = PLAN[S.plan].name + (S.serum ? ' + serum' : '') + ' · save $' + t.save;
      $('#sb-price').innerHTML = money(t.mo) + '/mo<s>' + money(t.regMo) + '</s>';
    } else {
      go.disabled = true; go.textContent = 'Pick a supply to get started';
    }
    sticky();
  }
  $$('[data-rx]').forEach(function(b){ b.addEventListener('click', function(){
    S.rx = b.getAttribute('data-rx'); if (!S.plan) S.plan = '3'; renderBuilder();
    hold(W.innerWidth < 1000 ? 800 : 500);
    if (W.innerWidth < 1000){ var y = steps.getBoundingClientRect().top + W.pageYOffset - 12; W.scrollTo({top:y, behavior:'smooth'}); }
  }); });
  $('#b-change').addEventListener('click', function(){ S.rx = ''; renderBuilder(); hold(); });
  $$('.plan').forEach(function(b){ b.addEventListener('click', function(){ S.plan = b.getAttribute('data-plan'); renderBuilder(); }); });
  $('#b-serum-btn').addEventListener('click', function(){ S.serum = !S.serum; renderBuilder(); });
  $('#s-go').addEventListener('click', function(){ if (S.plan) checkout(S.plan, S.serum, this); });
  $('#sb-go').addEventListener('click', function(){ if (S.plan) checkout(S.plan, S.serum, this); });
  $$('[data-buy]').forEach(function(b){ b.addEventListener('click', function(){
    var k = b.getAttribute('data-buy'); checkout(k.charAt(0), k.length > 1, b);
  }); });

  // phone: sticky bar while the builder is on screen and the panel button is not
  var bar = $('#sbar'), build = $('#builder');
  function sticky(){
    if (W.innerWidth >= 1000 || !S.plan || !S.rx || !qzEl.hidden){ bar.hidden = true; return; }
    var r = build.getBoundingClientRect(), g = $('#s-go').getBoundingClientRect(), h = W.innerHeight;
    var inBuild = r.top < h * 0.6 && r.bottom > h * 0.4, goVisible = g.top < h - 70 && g.bottom > 0;
    bar.hidden = !(inBuild && !goVisible);
  }
  W.addEventListener('scroll', function(){ W.requestAnimationFrame(sticky); }, {passive:true});
  W.addEventListener('resize', sticky);

  // prefill from the URL (?plan=3&serum=yes&rx=yes), e.g. from the plan email (Klaviyo profile properties)
  (function(){
    var q = new URLSearchParams(W.location.search);
    if (/^[136]$/.test(q.get('plan') || '')){ S.plan = q.get('plan'); S.rx = q.get('rx') === 'no' ? 'no' : 'yes'; }
    if (/^(1|yes)$/.test(q.get('serum') || '') && S.plan) S.serum = true;
  })();

  // ---------- Klaviyo (client API · public key only) ----------
  function subscribe(email, first, props){
    var attrs = {email:email, properties:props};
    if (first) attrs.first_name = first;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO.company, {
      method:'POST', headers:{'Content-Type':'application/vnd.api+json', 'revision':KLAVIYO.rev},
      body:JSON.stringify({data:{type:'subscription', attributes:{custom_source:'LP-15 Coach Mike · ' + props.lp15_source,
        profile:{data:{type:'profile', attributes:attrs}}}, relationships:{list:{data:{type:'list', id:KLAVIYO.list}}}}})
    }).then(function(r){ if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
  }
  // no "..", no dot before @, no empty label, no trailing dot, a TLD of 2+ letters
  var EMAIL = /^(?!.*\.\.)(?!.*\.@)[^\s@.][^\s@]*@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.\d]{2,}$/;
  function input(type, name, ph, req, onEnter){
    var i = D.createElement('input'); i.type = type; i.name = name; i.placeholder = ph; i.autocomplete = name === 'email' ? 'email' : 'given-name';
    if (req) i.required = true; if (type === 'email') i.inputMode = 'email'; i.setAttribute('aria-label', ph);
    if (onEnter) i.addEventListener('keydown', function(e){ if (e.key === 'Enter'){ e.preventDefault(); onEnter(); } });
    return i;
  }

  // ---------- free plan form ----------
  (function(){
    var box = $('#lm-fields'); if (!box) return;
    var go = $('#lm-go'), msg = $('#lm-msg'), pdf = go.getAttribute('data-pdf');
    var fn = input('text', 'first_name', 'First name (optional)', false, function(){ go.click(); }), em = input('email', 'email', 'Email address', true, function(){ go.click(); });
    box.appendChild(fn); box.appendChild(em);
    go.addEventListener('click', function(){
      var e = em.value.trim();
      if (!EMAIL.test(e)){ em.classList.add('bad'); em.focus(); return; }
      em.classList.remove('bad'); go.disabled = true; go.textContent = 'Sending…';
      subscribe(e, fn.value.trim(), {lp15_source:'free plan'}).then(function(){
        box.hidden = true; go.hidden = true; msg.hidden = false;
        msg.innerHTML = "Done. Check your inbox: the plan is on its way." + (pdf ? ' <a href="' + pdf + '" target="_blank" rel="noopener">Download it now</a>.' : '');
      }).catch(function(){
        go.disabled = false; go.innerHTML = 'Send me the plan <i class="ic i-arrow"></i>';
        msg.hidden = false; msg.textContent = "That didn't go through. Check your email address and try again.";
      });
    });
  })();

  // ---------- the 60-second quiz ----------
  var QS = [
    {id:'notice', multi:true, t:"What are you noticing most right now?", sub:"<b>Choose as many as you like.</b> Check everything that sounds like you.",
     o:[['strength',"I don't feel as strong",'i-strength'], ['stairs',"I'm out of breath on the stairs",'i-stairs'], ['chair',"I'm asleep in the chair by eight",'i-moon'],
        ['heavy','The younger guys take the heavy end','i-box'], ['shirts','My shirts hang off me','i-shirt'], ['groceries',"I'm winded carrying the groceries in",'i-bag']],
     why:"These are what men on a GLP-1 tell me about most. Whichever ones sound like you are what I build your plan around."},
    {id:'want', t:"What do you want back most?", sub:"<b>Choose one.</b> This becomes the thing your whole plan is built around.",
     o:[['work','Carrying my end at work','i-hardhat'], ['kids','Keeping up with my kids or grandkids','i-heart'], ['saturdays','My Saturdays: projects, not naps','i-wrench'],
        ['lake','My shirt off at the lake','i-waves'], ['me','Just feeling like myself again','i-user']],
     why:"When you eat this little, something usually gives. Knowing what you're least willing to lose tells me where to start."},
    {id:'glp1', t:"Are you on a GLP-1, and for how long?", sub:"Any GLP-1 counts: the weekly shot or a daily pill, brand-name or compounded.",
     o:[['no',"Not yet, I'm considering it"], ['new','Just started'], ['months','A few months in'], ['six','Six months or more']],
     why:"The first weeks and the six-month mark are different problems. The faster the weight comes off, the more muscle is at stake."},
    {id:'keep', t:"How do you like to keep things?", sub:"<b>Choose one.</b>",
     o:[['simple','Keep it simple: one month at a time'], ['unsure','Not sure, show me where most men start'], ['long',"I'm in it for the long haul"]],
     why:"The plan that works is the one you're still on in three months. So I want it to fit how you live."}
  ];
  var NOTICE = {strength:"you don't feel as strong", stairs:'the stairs leave you out of breath', chair:"you're asleep in the chair by eight",
    heavy:'the younger guys take the heavy end', shirts:'your shirts hang off you', groceries:'carrying the groceries in leaves you winded'};
  var WANT = {work:'You want to carry your end at work again.', kids:'You want to keep up with your kids or grandkids again.', saturdays:'You want your Saturdays back: projects, not naps.',
    lake:'You want your shirt off at the lake again.', me:'You want to feel like yourself again.'};
  var STAGE = {no:'not on a GLP-1 yet', 'new':'just starting your GLP-1', months:'a few months into your GLP-1', six:'six months or more into your GLP-1'};
  var KEEP_PLAN = {simple:'1', unsure:'3', 'long':'6'};
  var PLAN_WHY = {'1':'One month at a time, like you asked: $15 off every delivery, and you can cancel anytime.',
    '3':'Three months is where most men start: long enough to make it a habit, and $75 off every delivery.',
    '6':"You're in it for the long haul, so I gave you the best price: $210 off every delivery."};

  var qzEl = $('#quiz'), card = $('#qz-card');
  // decided = plan/serum worked out from the current answers · sent = these answers went to Klaviyo
  var Z = {i:0, a:{notice:[]}, name:'', email:'', plan:'3', serum:false, auto:false, decided:false, sent:false};
  var timers = [];
  function later(fn, ms){ timers.push(setTimeout(fn, ms)); }
  function stopTimers(){ timers.forEach(clearTimeout); timers = []; }
  function label(q, k){ for (var j = 0; j < q.o.length; j++) if (q.o[j][0] === k) return q.o[j][1]; return k; }
  function top(n, total){
    return '<div class="qz-top"><div class="n">' + n + '</div><div class="qz-bar"><i style="width:' + total + '%"></i></div>' +
      '<button class="qz-x" type="button" aria-label="Close the quiz" data-close><i class="ic i-x"></i></button></div>';
  }
  function why(t){ return '<div class="qz-why">' + (COACH ? '<img src="' + COACH + '" alt="">' : '') + '<div><b>Why I\'m asking</b>' + t + '</div></div>'; }
  function showQ(){
    stopTimers();
    var q = QS[Z.i], h = top('Question ' + (Z.i + 1) + ' of ' + QS.length, Math.round((Z.i + 1) / (QS.length + 1) * 100));
    h += '<div class="qz-body"><h3 id="qz-title">' + q.t + '</h3><p class="qz-sub">' + q.sub + '</p>';
    if (q.multi){
      h += '<div class="qz-tiles">' + q.o.map(function(o){
        var on = Z.a[q.id].indexOf(o[0]) > -1;
        return '<button class="qz-tile' + (on ? ' on' : '') + '" type="button" aria-pressed="' + on + '" data-k="' + o[0] + '"><i class="ic ' + o[2] + '"></i>' + o[1] + '</button>';
      }).join('') + '</div><button class="btn wide qz-go" type="button" data-next' + (Z.a[q.id].length ? '' : ' disabled') + '>Continue <i class="ic i-arrow"></i></button>';
    } else {
      h += '<div class="qz-rows">' + q.o.map(function(o){
        var on = Z.a[q.id] === o[0];
        return '<button class="qz-row' + (on ? ' on' : '') + '" type="button" role="radio" aria-checked="' + on + '" data-k="' + o[0] + '">' + (o[2] ? '<i class="ic ' + o[2] + '"></i>' : '') + '<span>' + o[1] + '</span><i class="r"></i></button>';
      }).join('') + '</div>';
    }
    if (Z.i > 0) h += '<button class="qz-back" type="button" data-back><i class="ic i-left"></i>Back</button>';
    h += why(q.why) + '</div>';
    card.innerHTML = h; card.scrollTop = 0; qzEl.scrollTop = 0; card.focus({preventScroll:true}); hold();
  }
  function loader(){
    stopTimers();
    var a = Z.a, lines = [
      "You're noticing: " + a.notice.map(function(k){ return label(QS[0], k); }).join(' · '),
      'You want back: ' + label(QS[1], a.want),
      'On a GLP-1: ' + label(QS[2], a.glp1),
      'You like it: ' + label(QS[3], a.keep)
    ];
    card.innerHTML = top('Building your plan', 90) + '<div class="qz-load"><div class="qz-spin"></div><h3>Building your plan</h3><p>Reading back what you told me.</p><ul class="qz-echo">' +
      lines.map(function(l){ return '<li><i class="ic i-check"></i><span>' + esc(l) + '</span></li>'; }).join('') + '</ul></div>';
    card.focus({preventScroll:true});
    $$('.qz-echo li', card).forEach(function(li, i){ later(function(){ li.classList.add('in'); }, 500 + i * 900); });
    later(gateView, 5000);
  }
  function gateView(){
    stopTimers();
    card.innerHTML = top('Last step', 100) + '<div class="qz-body qz-gate"><div class="qz-chip"><i class="ic i-lock"></i>Your results are ready</div>' +
      '<h3>Unlock your results</h3><p class="qz-sub">Your plan is built. I\'ll email you a link back to it, plus my free two-page plan, <i>Lighter, Not Weaker</i>.</p>' +
      '<div class="fields" id="qz-fields"></div><button class="btn wide" type="button" id="qz-see">See my results <i class="ic i-arrow"></i></button>' +
      '<p class="qz-consent">By continuing, you agree to get emails from MYOTIDE. Unsubscribe anytime.</p></div>';
    var see = function(){ var b = $('#qz-see', card); if (b) b.click(); };
    var f = $('#qz-fields', card), fn = input('text', 'first_name', 'First name', true, see), em = input('email', 'email', 'Email address', true, see);
    fn.value = Z.name; em.value = Z.email; f.appendChild(fn); f.appendChild(em); fn.focus();
    $('#qz-see', card).addEventListener('click', function(){
      var n = fn.value.trim(), e = em.value.trim(), ok = true;
      fn.classList.toggle('bad', !n); em.classList.toggle('bad', !EMAIL.test(e));
      if (!n || !EMAIL.test(e)){ (n ? em : fn).focus(); return; }
      Z.name = n; Z.email = e;
      if (!Z.sent){ Z.sent = true; subscribe(e, n, {lp15_source:'quiz', lp15_plan:Z.plan, lp15_serum:Z.serum ? 'yes' : 'no', lp15_rx:Z.a.glp1 === 'no' ? 'no' : 'yes',
        lp15_glp1:Z.a.glp1, lp15_notice:Z.a.notice, lp15_want:Z.a.want}).catch(function(){ Z.sent = false; }); }
      result();
    });
  }
  function result(){
    stopTimers();
    var a = Z.a, rx = a.glp1 === 'no' ? 'no' : 'yes', t = totals(Z.plan, Z.serum), p = PLAN[Z.plan], s = SERUM[Z.plan];
    var first = a.notice.length ? NOTICE[a.notice[0]] : "you just don't feel like yourself";
    var p1 = 'You told me you\'re ' + STAGE[a.glp1] + ' and ' + first + '. ' + (rx === 'yes'
      ? "That's the part nobody warned you about. The shot does exactly what it promises. It just can't tell fat from muscle."
      : 'After 40, the build switch in your muscle gets stiff and the brake on breakdown gets weaker. That\'s not “just aging.” It\'s your muscle.');
    var words = rx === 'yes' ? 'HMB, the stop signal. Leucine, the build switch. Ketones, clean fuel for the days you can\'t eat.' : 'HMB, the stop signal. Leucine, the build switch. D3 for muscle function.';
    var p2 = "So here's where I'd start you: two small gummies a day with your coffee. Three words do the work: " + words;
    var p3 = WANT[a.want] + " That's what this plan is built around. " + PLAN_WHY[Z.plan];
    var sw = Z.serum && Z.auto ? (a.notice.indexOf('shirts') > -1 ? 'You told me your shirts hang off you' : 'You want your shirt off at the lake') +
      ', so I added the GHK-Cu Serum for firmer-looking skin while the weight comes off. Take it out if you don\'t want it.' : '';
    var serumRow = '<li class="' + (Z.serum ? '' : 'off') + '"><img src="' + imgOf('#b-serum img') + '" alt=""><span><b>GHK-Cu Serum</b><small>' + s.bottles + ' · firmer-looking skin</small>' +
      '<button class="lnk tog" type="button" data-serum>' + (Z.serum ? 'Remove' : '+ Add it to my plan') + '</button></span><em>' + (Z.serum ? '' : '+') + money(perMo(s, p.m)) + '/mo</em></li>';
    var h = top('Your plan', 100) + '<div class="qz-body qz-res"><div class="rsub">Based on your answers</div><h3 class="rtitle" id="qz-title">' + esc(Z.name) + (rx === 'yes' ? '\'s GLP-1 Muscle Plan' : '\'s Muscle Plan') + '</h3>' +
      '<ul class="ritems"><li><img src="' + imgOf('.plan[data-plan="' + Z.plan + '"] img') + '" alt=""><span><b>The Preserve Stack</b><small>' + p.bags + '</small></span><em>' + money(perMo(p, p.m)) + '/mo</em></li>' + serumRow + '</ul>' +
      '<div class="rtot"><b>' + money(t.mo) + '/mo</b><s>' + money(t.regMo) + '</s><span>You save $' + t.save + ' every delivery</span></div>' +
      '<button class="btn wide" type="button" data-start>Start my plan <i class="ic i-arrow"></i></button>' +
      '<div class="rtrust"><span>90-day money-back guarantee</span><span>Free shipping</span><span>Cancel anytime</span></div>' +
      '<div class="rnote">' + (COACH ? '<img src="' + COACH + '" alt="">' : '') + '<div><b class="rwhy">Why I picked this for you</b><p>' + esc(p1) + '</p><p>' + esc(p2) + '</p><p>' + esc(p3 + (sw ? ' ' + sw : '')) + '</p></div></div>' +
      '<div class="rlinks"><button type="button" data-redo>Start over</button><button class="lnk" type="button" data-edit>Change it in the builder <i class="ic i-arrow"></i></button></div></div>';
    card.innerHTML = h; card.scrollTop = 0; qzEl.scrollTop = 0; card.focus({preventScroll:true}); hold();
  }
  function decide(){
    Z.plan = KEEP_PLAN[Z.a.keep] || '3';
    Z.serum = Z.auto = Z.a.notice.indexOf('shirts') > -1 || Z.a.want === 'lake';
    Z.decided = true;
  }
  card.addEventListener('click', function(e){
    var b = e.target.closest('button'); if (!b) return;
    var q = QS[Z.i];
    if (b.hasAttribute('data-close')) return closeQuiz();
    if (b.hasAttribute('data-back')){ Z.i = Math.max(0, Z.i - 1); return showQ(); }
    if (b.classList.contains('qz-tile')){
      var k = b.getAttribute('data-k'), arr = Z.a[q.id], at = arr.indexOf(k);
      if (at > -1) arr.splice(at, 1); else arr.push(k);
      Z.decided = false;
      b.classList.toggle('on', at < 0); b.setAttribute('aria-pressed', at < 0 ? 'true' : 'false');
      $('[data-next]', card).disabled = !arr.length; return;
    }
    if (b.hasAttribute('data-next')){ Z.i++; return showQ(); }
    if (b.classList.contains('qz-row')){
      if (timers.length) return;   // one pick per question: a double click must not skip the next one
      Z.a[q.id] = b.getAttribute('data-k'); Z.decided = false;
      $$('.qz-row', card).forEach(function(x){ var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      later(function(){ timers = []; if (Z.i < QS.length - 1){ Z.i++; showQ(); } else { decide(); loader(); } }, 260);
      return;
    }
    if (b.hasAttribute('data-serum')){ Z.serum = !Z.serum; Z.auto = false; return result(); }
    if (b.hasAttribute('data-start')) return checkout(Z.plan, Z.serum, b);
    if (b.hasAttribute('data-redo')){ Z.i = 0; Z.a = {notice:[]}; Z.decided = Z.sent = false; return showQ(); }
    if (b.hasAttribute('data-edit')){
      S.rx = Z.a.glp1 === 'no' ? 'no' : 'yes'; S.plan = Z.plan; S.serum = Z.serum; closeQuiz(); renderBuilder(); hold(800);
      var y = $('.bcard').getBoundingClientRect().top + W.pageYOffset - 10; W.scrollTo({top:y, behavior:'smooth'});
    }
  });
  var lastFocus = null;
  function openQuiz(){
    lastFocus = D.activeElement; qzEl.hidden = false; D.documentElement.classList.add('qz-open');
    // closed right after the last answer: the plan was never worked out · new answers not sent yet: through the gate again
    if (Z.a.keep && !Z.decided) decide();
    if (Z.a.keep && Z.sent) result(); else if (Z.a.keep) gateView(); else showQ();
    card.focus(); sticky(); hold();
  }
  function closeQuiz(){ stopTimers(); qzEl.hidden = true; D.documentElement.classList.remove('qz-open'); if (lastFocus) lastFocus.focus(); sticky(); hold(); }
  $$('[data-quiz]').forEach(function(b){ b.addEventListener('click', openQuiz); });
  var downOut = false;
  qzEl.addEventListener('pointerdown', function(e){ downOut = e.target === qzEl; });
  qzEl.addEventListener('click', function(e){ if (e.target === qzEl && downOut) closeQuiz(); });
  D.addEventListener('keydown', function(e){
    if (qzEl.hidden) return;
    if (e.key === 'Escape') return closeQuiz();
    if (e.key !== 'Tab') return;
    var f = $$('button, input, a[href]', card).filter(function(x){ return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && (D.activeElement === f[0] || D.activeElement === card)){ e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && D.activeElement === f[f.length - 1]){ e.preventDefault(); f[0].focus(); }
  });
  if (/(^|#)quiz$/.test(W.location.hash)) openQuiz();

  renderBuilder();

  // draft blocks only with ?draft
  if (/[?&]draft\b/.test(W.location.search)) $$('[data-draft]').forEach(function(e){ e.hidden = false; });
  // Light Labs widget (same embed as the men PDP) · loaded here because page bodies drop <script src>
  $$('.pdp-ll').forEach(function(box){ if (!box.querySelector('lightlabs-widget')){ var w = D.createElement('lightlabs-widget'); w.setAttribute('company-id', '1218'); w.setAttribute('product-id', '8587'); w.style.display = 'block'; box.appendChild(w); } });
  // load the Light Labs script only when its badge comes near the screen (keeps the first paint free of it)
  (function(){
    var box = $('.pdp-ll'), done = false;
    function load(){ if (done) return; done = true; var s = D.createElement('script'); s.async = true; s.src = 'https://app.lightlabs.com/assets/ll-pip-widget-v5.js'; D.head.appendChild(s); }
    if (!box) return;
    if ('IntersectionObserver' in W){ var io = new IntersectionObserver(function(es){ if (es.some(function(e){ return e.isIntersecting; })){ io.disconnect(); load(); } }, {rootMargin:'900px 0px'}); io.observe(box); }
    else load();
  })();
  // Inter without blocking the first paint
  (function(){ var l = D.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap'; D.head.appendChild(l); })();
})();